import { render, staticRenderFns } from "./DemoCenterBar.vue?vue&type=template&id=435b0af4&scoped=true"
import script from "./DemoCenterBar.vue?vue&type=script&lang=js"
export * from "./DemoCenterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435b0af4",
  null
  
)

export default component.exports